import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { Tooltip } from '@meitu/saas-ui';
import { TextLayerExtension } from '@meitu/saas-editor-core/es/editor/layer-extensions/text-layer';
import { HoverExtendType, IHoverExtendArgs } from '@meitu/saas-editor-core/es/framework';
import { isHotKeyPress } from '@meitu/saas-editor-core/es/utils/event-kit';
import IconFont from '@meitu/xdesign-icon-font';
import { useEditor } from '@/hooks/use-editor';
import { useLocaleStore } from '@/i18n';
import { ICallback, IToolLayout } from '../../types';

const TextBrushBtn = ({
    id,
    onCopyBrush,
    onApplyBrush,
}: Pick<IToolLayout & ICallback, 'id' | 'onCopyBrush' | 'onApplyBrush'>) => {
    const { $t } = useLocaleStore();
    const editor = useEditor();

    const [hoverExtend, setHoverExtend] = useState<IHoverExtendArgs | null>(editor.layer.getHoverExtend());

    useEffect(() => {
        setHoverExtend(editor.getInstance(TextLayerExtension).getHoverExtend());
        const handler = editor.getInstance(TextLayerExtension).onHoverExtend((args) => {
            setHoverExtend(args);
        });
        return () => {
            if (!isHotKeyPress()) editor.getInstance(TextLayerExtension).clearHoverExtend();
            editor.off(handler);
        };
    }, [id]);

    return (
        <Tooltip placement="bottom" title={$t((v) => v.headerToolbar.textBrushBtn.copyStyle)}>
            <div
                onClick={() => {
                    editor.getInstance(TextLayerExtension).extractFormatBrushData(id);
                    editor.getInstance(TextLayerExtension).setTextBrush(
                        id,
                        (layerId) => {
                            editor.getInstance(TextLayerExtension).applyFormatBrush(layerId);
                            onApplyBrush?.();
                        },
                        $t((v) => v.baseLayer.shortcutOperate.cursorTip),
                    );
                    onCopyBrush?.();
                }}
                className={classNames('c-header-toolbar-actions-btn', {
                    active: hoverExtend?.type === HoverExtendType.TEXT_BRUSH && hoverExtend?.layerId === id,
                })}
            >
                <IconFont fontSize={14} name="FormatPainterBold" />
            </div>
        </Tooltip>
    );
};

export default React.memo(TextBrushBtn);
